module.exports = __webpack_public_path__ + "static/media/offers.71509a9e.png";